import { render, staticRenderFns } from "./group-member.vue?vue&type=template&id=119f03d6&scoped=true&lang=pug&"
import script from "./group-member.vue?vue&type=script&lang=js&"
export * from "./group-member.vue?vue&type=script&lang=js&"
import style0 from "./group-member.vue?vue&type=style&index=0&id=119f03d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119f03d6",
  null
  
)

export default component.exports